import React, { useId } from 'react';
import { InputText } from 'primereact/inputtext';
import FieldShell from './FieldShell';

/**
 * AppTextField — wraps PrimeReact InputText with FieldShell.
 */
const AppTextField = ({
    label,
    value,
    onChange,
    placeholder,
    helperText,
    errorMessage,
    required = false,
    invalid = false,
    disabled = false,
    readOnly = false,
    fluid = true,
    className = '',
    trailing,
    addonRight,
    keyfilter,
    ...rest
}) => {
    const autoId = useId();
    const id = rest.id || autoId;

    const inputCls = [
        'fk-input',
        invalid && 'fk-input--invalid',
        disabled && 'fk-input--disabled',
        readOnly && 'fk-input--readonly',
    ].filter(Boolean).join(' ');

    return (
        <FieldShell
            label={label}
            htmlFor={id}
            required={required}
            helperText={helperText}
            errorMessage={errorMessage}
            invalid={invalid}
            disabled={disabled}
            readOnly={readOnly}
            fluid={fluid}
            className={className}
            trailing={trailing}
        >
            <div className={inputCls} style={addonRight ? { position: 'relative' } : undefined}>
                <InputText
                    id={id}
                    value={value ?? ''}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                    keyfilter={keyfilter}
                    style={addonRight ? { paddingRight: '2.25rem' } : undefined}
                    {...rest}
                />
                {addonRight && (
                    <span style={{ position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                        {addonRight}
                    </span>
                )}
            </div>
        </FieldShell>
    );
};

export default AppTextField;
